/** Public SPA paths (no react-router — pathname sync in App.jsx). */

export const POLICIES_PATH = '/policies';
export const DELETE_ACCOUNT_PATH = '/delete-account';

const POLICY_TAB_IDS = new Set(['terms', 'privacy', 'refund', 'disclaimer', 'contact']);

export function isPoliciesPath(pathname = window.location.pathname) {
  return pathname === POLICIES_PATH || pathname.startsWith(`${POLICIES_PATH}/`);
}

export function isDeleteAccountPath(pathname = window.location.pathname) {
  return pathname === DELETE_ACCOUNT_PATH || pathname.startsWith(`${DELETE_ACCOUNT_PATH}/`);
}

/** Tab from /policies/privacy or ?tab=privacy; bare /policies → privacy (App Store policy URL). */
export function policiesTabFromLocation(loc = window.location) {
  const rest = loc.pathname.slice(POLICIES_PATH.length).replace(/^\//, '');
  const segment = rest.split('/')[0];
  if (segment && POLICY_TAB_IDS.has(segment)) return segment;
  const q = new URLSearchParams(loc.search).get('tab');
  if (q && POLICY_TAB_IDS.has(q)) return q;
  if (isPoliciesPath(loc.pathname)) return 'privacy';
  return null;
}

export function policiesUrl(tab) {
  if (tab && tab !== 'privacy' && POLICY_TAB_IDS.has(tab)) {
    return `${POLICIES_PATH}/${tab}`;
  }
  return POLICIES_PATH;
}
